import React, { useState } from 'react';

function EmiCalculator() {
    const [formData, setFormData] = useState({
        loan_amount: '',
        interest_rate: '',
        tenure_months: ''
    });

    const [emiResult, setEmiResult] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCalculate = () => {
        const { loan_amount, interest_rate, tenure_months } = formData;

        const P = parseFloat(loan_amount);
        const rate = parseFloat(interest_rate);
        const N = parseInt(tenure_months);

        if (!P || !rate || !N) return;

        // Round each monthly component to nearest integer
        const principalPerMonth = Math.round(P / N);
        const interestPerMonth = Math.round((P / 100) * rate);
        const totalEMIPerMonth = principalPerMonth + interestPerMonth;

        // Multiply back to get total repayment
        const totalRepayment = totalEMIPerMonth * N;

        setEmiResult({
            loanAmount: P,
            principalPerMonth,
            interestPerMonth,
            totalEMIPerMonth,
            totalRepayment
        });
    };


    const handleClear = () => {
        setFormData({
            loan_amount: '',
            interest_rate: '',
            tenure_months: ''
        });
        setEmiResult(null);
    };

    return (
        <div className="content-wrapper">
            {/* Header */}
            <div className="content-header bg-light shadow-sm rounded mb-3 py-2">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-sm-6">
                            <h1 className="m-0">EMI Calculator</h1>
                        </div>
                        <div className="col-sm-6 text-sm-right">
                            <ol className="breadcrumb float-sm-right bg-transparent p-0 m-0">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active text-muted">EMI Calculator</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            {/* EMI Form */}
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow-lg border-0 rounded-lg">
                        <div className="card-header bg-gradient-dark text-white">
                            <h3 className="card-title mb-0"><i className="fas fa-coins mr-2"></i>EMI Calculation Form</h3>
                        </div>
                        <div className="card-body bg-light">
                            <form>
                                <div className="row">
                                    <div className="col-sm-6 mb-3">
                                        <label><strong>Loan Amount (₹)</strong></label>
                                        <input
                                            type="number"
                                            name="loan_amount"
                                            className="form-control shadow-sm"
                                            placeholder="e.g. 100000"
                                            value={formData.loan_amount}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-sm-6 mb-3">
                                        <label><strong>Interest Rate (%)</strong></label>
                                        <input
                                            type="number"
                                            name="interest_rate"
                                            className="form-control shadow-sm"
                                            placeholder="e.g. 10"
                                            value={formData.interest_rate}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-sm-6 mb-3">
                                        <label><strong>Tenure (Months)</strong></label>
                                        <input
                                            type="number"
                                            name="tenure_months"
                                            className="form-control shadow-sm"
                                            placeholder="e.g. 12"
                                            value={formData.tenure_months}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="d-flex gap-2 mt-3">
                                    <button type="button" className="btn btn-success mr-2 shadow" onClick={handleCalculate}>
                                        <i className="fas fa-equals mr-1"></i>Calculate
                                    </button>
                                    <button type="button" className="btn btn-outline-secondary shadow" onClick={handleClear}>
                                        <i className="fas fa-redo-alt mr-1"></i>Clear
                                    </button>
                                </div>
                            </form>

                            {/* EMI Result */}
                            {emiResult && (
                                <div className="mt-4 bg-white p-3 rounded shadow-sm border">
                                    <h5 className="text-info"><i className="fas fa-receipt mr-2"></i>EMI Result</h5>
                                    <ul className="list-group list-group-flush mt-2">
                                        <li className="list-group-item d-flex justify-content-between">
                                            <span>Loan Amount:</span><strong>₹{emiResult.loanAmount}</strong>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between">
                                            <span>Principal / Month:</span><strong>₹{emiResult.principalPerMonth}</strong>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between">
                                            <span>Interest / Month:</span><strong>₹{emiResult.interestPerMonth}</strong>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between">
                                            <span>Total EMI / Month:</span><strong>₹{emiResult.totalEMIPerMonth}</strong>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between">
                                            <span>Total Repayment:</span><strong>₹{emiResult.totalRepayment}</strong>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default EmiCalculator;
